import { z } from 'zod';

export const Material = z.enum([
  'PLA',
  'PLA Silk',
  'PLA Matte',
  'PETG',
  'TPU',
  'ABS',
  'ASA',
  'PC',
  'Outro',
]);
export type Material = z.infer<typeof Material>;

/** Printer power group: PLA/PETG/TPU draw little; ABS/ASA/PC heat the bed and chamber. */
export type PowerGroup = 'low' | 'high';

export interface MaterialDefaults {
  density: number;
  nozzleTempC: number;
  bedTempC: number;
  powerGroup: PowerGroup;
}

/** Defaults from the Filamentos board (density g/cm³, temperatures °C). */
export const MATERIAL_DEFAULTS: Record<Material, MaterialDefaults> = {
  PLA: { density: 1.24, nozzleTempC: 220, bedTempC: 55, powerGroup: 'low' },
  'PLA Silk': { density: 1.32, nozzleTempC: 230, bedTempC: 55, powerGroup: 'low' },
  'PLA Matte': { density: 1.24, nozzleTempC: 220, bedTempC: 55, powerGroup: 'low' },
  PETG: { density: 1.25, nozzleTempC: 250, bedTempC: 70, powerGroup: 'low' },
  TPU: { density: 1.22, nozzleTempC: 230, bedTempC: 35, powerGroup: 'low' },
  ABS: { density: 1.04, nozzleTempC: 260, bedTempC: 90, powerGroup: 'high' },
  ASA: { density: 1.07, nozzleTempC: 260, bedTempC: 90, powerGroup: 'high' },
  PC: { density: 1.2, nozzleTempC: 270, bedTempC: 100, powerGroup: 'high' },
  Outro: { density: 1.24, nozzleTempC: 220, bedTempC: 55, powerGroup: 'low' },
};

export const POWER_GROUP_LABELS: Record<PowerGroup, string> = {
  low: 'PLA, PETG, TPU',
  high: 'ABS, ASA, PC',
};

export const MaterialInfo = z.object({
  material: Material,
  density: z.number(),
  nozzleTempC: z.number().int(),
  bedTempC: z.number().int(),
  powerGroup: z.enum(['low', 'high']),
});
export const MaterialList = z.object({ data: z.array(MaterialInfo) }).meta({ id: 'MaterialList' });
